import axios from 'axios';
import styled from 'styled-components';
import { PointsContext, PointsProvider } from './pointContext';
import { animated, useSpring } from "react-spring";
import { useState,useEffect, Fragment, createContext, useContext  } from 'react';
import { Routes, Route , useNavigate, NavLink,Link} from "react-router-dom";



const HeroWrapper = styled.section`

  gap: 1.5rem; /* Equivalent to gap-6 */
  min-height: 480px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.4) 100%), url("https://lh3.googleusercontent.com/aida-public/AB6AXuCW1fXzR-BdRZefaq_EdlG4NGNb2C4G2a4DYO3XQMMDElT_cEuPPb2i24V7ANt5zPPurGbOBJeKGe83lTUhmJhBp8iQevCogYJa009h7hSgkAfhnY7Ho76OzXTUbVBcIdSx_5U5zrZq_C9zDLD4KHzX6ipb5DCaJXCXgkm6JkwamTZS_uent0tf0drIgF5SROSdZ7s7DRXMSgGYvimYp1yP8tkieg5jg0aG6HGbOyQsJo5KDUFsN9MrYOpL5UgotuweUnV4XldOQXU");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 0 1rem 2.5rem 1rem; /* px-4 pb-10 */

  @media (min-width: 480px) { /* Equivalent to @[480px] */
    gap: 2rem; /* Equivalent to @[480px]:gap-8 */
    border-radius: 0.75rem; /* Equivalent to @[480px]:rounded-xl */
    padding: 0 2.5rem 2.5rem 2.5rem; /* @[480px]:px-10 */
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem; /* Equivalent to gap-2 */
  text-align: left;
`;

const HeroTitle = styled.h1`
  color: #fff;
  font-size: 2.25rem; /* text-4xl */
  font-weight: 900; /* font-black */
  line-height: 1.25; /* leading-tight */
  letter-spacing: -0.033em; /* tracking-[-0.033em] */

  @media (min-width: 480px) {
    font-size: 3rem; /* @[480px]:text-5xl */
    line-height: 1.25;
  }
`;

const HeroSubtitle = styled.h2`
  color: #fff;
  font-size: 0.875rem; /* text-sm */
  font-weight: 400; /* font-normal */
  line-height: 1.5; /* leading-normal */

  @media (min-width: 480px) {
    font-size: 1rem; /* @[480px]:text-base */
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem; /* gap-3 */
`;

const PrimaryButton = styled.button`
  display: flex;
  min-width: 84px;
  max-width: 480px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 0.75rem; /* rounded-xl */
  height: 2.5rem; /* h-10 */
  padding: 0 1rem; /* px-4 */
  background-color: #dce8f3; /* bg-[#dce8f3] */
  color: #121416; /* text-[#121416] */
  font-size: 0.875rem; /* text-sm */
  font-weight: 700; /* font-bold */
  line-height: 1.5; /* leading-normal */
  letter-spacing: 0.015em; /* tracking-[0.015em] */

  span {
    white-space: nowrap; /* truncate */
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (min-width: 480px) {
    height: 3rem; /* @[480px]:h-12 */
    padding: 0 1.25rem; /* @[480px]:px-5 */
    font-size: 1rem; /* @[480px]:text-base */
  }
`;

const SecondaryButton = styled(PrimaryButton)`
  background-color: #2c3135; /* bg-[#2c3135] */
  color: #fff; /* text-white */
`;

const HeroSection = () => (
  <HeroWrapper>
    <HeroContent>
      <HeroTitle>Unlock the Secrets of the Game</HeroTitle>
      <HeroSubtitle>
        Dive deep into basketball history with our advanced analytics platform. Compare players, analyze points,
        rebounds, assists, and predict team scores.
      </HeroSubtitle>
    </HeroContent>
    <ButtonGroup>
    <Link to="/signup" style={{ textDecoration: 'none' }}> {/* Remove underline if desired */}
  <PrimaryButton>
    <span>Sign Up</span>
  </PrimaryButton>
</Link>
<Link to="/pricing" style={{ textDecoration: 'none' }}> {/* Remove underline if desired */}

      <SecondaryButton><span>Learn More</span></SecondaryButton>
      </Link>
    </ButtonGroup>
  </HeroWrapper>
);




// src/components/ContentSection.js

const SectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 2.5rem; /* gap-10 */
  padding: 2.5rem 1rem; /* px-4 py-10 */

  @media (min-width: 480px) {
    /* Container queries are handled by media queries here */
  }
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem; /* gap-4 */
`;

const SectionTitle = styled.h1`
  color: #fff;
  letter-spacing: -0.015em; /* tracking-light (approx) */
  font-size: 2rem; /* text-[32px] */
  font-weight: 700; /* font-bold */
  line-height: 1.25; /* leading-tight */
  max-width: 720px;

  @media (min-width: 480px) {
    font-size: 2.25rem; /* @[480px]:text-4xl */
    font-weight: 900; /* @[480px]:font-black */
    letter-spacing: -0.033em;
  }
`;

const SectionDescription = styled.p`
  color: #fff;
  font-size: 1rem; /* text-base */
  font-weight: 400; /* font-normal */
  line-height: 1.5; /* leading-normal */
  max-width: 720px;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(158px, 1fr));
  gap: 0.75rem; /* gap-3 */
  padding: 0; /* p-0 */
`;

const FeatureCard = styled.div`
  display: flex;
  flex: 1; /* flex-1 */
  gap: 0.75rem; /* gap-3 */
  border-radius: 0.5rem; /* rounded-lg */
  border: 1px solid #40484f; /* border border-[#40484f] */
  background-color: #1e2124; /* bg-[#1e2124] */
  padding: 1rem; /* p-4 */
  flex-direction: column;
`;

const FeatureIcon = styled.div`
  color: #fff;
  /* SVG styles are inline in the original, you'd typically import as ReactComponent or inline SVG */
`;

const FeatureTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem; /* gap-1 */
`;

const FeatureTitle = styled.h2`
  color: #fff;
  font-size: 1rem; /* text-base */
  font-weight: 700; /* font-bold */
  line-height: 1.25; /* leading-tight */
`;

const FeatureDescription = styled.p`
  color: #a2abb3; /* text-[#a2abb3] */
  font-size: 0.875rem; /* text-sm */
  font-weight: 400; /* font-normal */
  line-height: 1.5; /* leading-normal */
`;

const ImageCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem; /* gap-3 */
  padding-bottom: 0.75rem; /* pb-3 */
`;

const ImagePlaceholder = styled.div`
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  aspect-ratio: 16 / 9; /* aspect-video */
  background-size: cover;
  border-radius: 0.75rem; /* rounded-xl */
`;

const ImageCardTitle = styled.p`
  color: #fff;
  font-size: 1rem; /* text-base */
  font-weight: 500; /* font-medium */
  line-height: 1.5; /* leading-normal */
`;

const ImageCardDescription = styled.p`
  color: #a2abb3; /* text-[#a2abb3] */
  font-size: 0.875rem; /* text-sm */
  font-weight: 400; /* font-normal */
  line-height: 1.5; /* leading-normal */
`;

const CTAWrapper = styled.section`
  @media (min-width: 480px) {
    /* This section has its own padding/gap logic */
  }
`;

const CTABlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 1.5rem; /* gap-6 */
  padding: 2.5rem 1rem; /* px-4 py-10 */

  @media (min-width: 480px) {
    gap: 2rem; /* @[480px]:gap-8 */
    padding: 5rem 2.5rem; /* @[480px]:px-10 @[480px]:py-20 */
  }
`;

const CTATextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem; /* gap-2 */
  text-align: center;
`;

const CTATitle = styled(SectionTitle)`
  max-width: 720px;
  margin: 0 auto; /* Center with max-width */
`;

const CTADescription = styled(SectionDescription)`
  max-width: 720px;
  margin: 0 auto; /* Center with max-width */
`;

const CTAButtonContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`;

const CTAButtonInner = styled.div`
  display: flex;
  justify-content: center;
`;

const CTAButton = styled(PrimaryButton)`
  flex-grow: 1; /* grow */
`;

const FooterSpacer = styled.div`
  height: 1.25rem; /* h-5 */
  background-color: #121416;
`;


const Home = () => (
  <div style={{
    position: 'relative',
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    flexDirection: 'column',
    backgroundColor: '#121416',
    justifyContent: 'space-between',
    overflowX: 'hidden',
    fontFamily: '"Space Grotesk", "Noto Sans", sans-serif'
  }}>
    <div> {/* This outer div exists in the original, perhaps for another layer of layout */}
      <HeroSection />
    </div>

    <div> {/* This div wraps the main content sections */}
      <SectionWrapper>
        <SectionHeader>
          <SectionTitle>Empowering Basketball Enthusiasts</SectionTitle>
          <SectionDescription>
            Our platform provides the tools and data you need to gain a competitive edge, whether you're a coach, player, or passionate fan.
          </SectionDescription>
        </SectionHeader>
        <FeaturesGrid>
          <FeatureCard>
            <FeatureIcon>
              {/* SVG for PresentationChart */}
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                <path d="M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.36L57.75,219a8,8,0,0,0,12.5,10l29.59-37h56.32l29.59,37a8,8,0,1,0,12.5-10l-21.61-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,136H40V56H216V176ZM104,120v24a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32-16v40a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm32-16v56a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"></path>
              </svg>
            </FeatureIcon>
            <FeatureTextContent>
              <FeatureTitle>Advanced Analytics</FeatureTitle>
              <FeatureDescription>Compare players, analyze points, rebounds, assists, and predict team scores.</FeatureDescription>
            </FeatureTextContent>
          </FeatureCard>
          <FeatureCard>
            <FeatureIcon>
              {/* SVG for UsersThree */}
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                <path d="M244.8,150.4a8,8,0,0,1-11.2-1.6A51.6,51.6,0,0,0,192,128a8,8,0,0,1-7.37-4.89,8,8,0,0,1,0-6.22A8,8,0,0,1,192,112a24,24,0,1,0-23.24-30,8,8,0,1,1-15.5-4A40,40,0,1,1,219,117.51a67.94,67.94,0,0,1,27.43,21.68A8,8,0,0,1,244.8,150.4ZM190.92,212a8,8,0,1,1-13.84,8,57,57,0,0,0-98.16,0,8,8,0,1,1-13.84-8,72.06,72.06,0,0,1,33.74-29.92,48,48,0,1,1,58.36,0A72.06,72.06,0,0,1,190.92,212ZM128,176a32,32,0,1,0-32-32A32,32,0,0,0,128,176ZM72,120a8,8,0,0,0-8-8A24,24,0,1,1,87.24,82a8,8,0,1,0,15.5-4A40,40,0,1,0,37,117.51,67.94,67.94,0,0,0,9.6,139.19a8,8,0,1,0,12.8,9.61A51.6,51.6,0,0,1,64,128,8,8,0,0,0,72,120Z"></path>
              </svg>
            </FeatureIcon>
            <FeatureTextContent>
              <FeatureTitle>Collaborative Insights</FeatureTitle>
              <FeatureDescription>Share insights and collaborate with your team or friends on game strategies.</FeatureDescription>
            </FeatureTextContent>
          </FeatureCard>
          <FeatureCard>
            <FeatureIcon>
              {/* SVG for Clock */}
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48A8,8,0,0,1,192,128Z"></path>
              </svg>
            </FeatureIcon>
            <FeatureTextContent>
              <FeatureTitle>Historical Data</FeatureTitle>
              <FeatureDescription>Explore decades of basketball data, from classic games to modern matches.</FeatureDescription>
            </FeatureTextContent>
          </FeatureCard>
        </FeaturesGrid>
      </SectionWrapper>

      <SectionWrapper>
        <SectionHeader>
          <SectionTitle>Key Features</SectionTitle>
          <SectionDescription>
            Explore the core functionalities of our application, designed to provide comprehensive insights into the world of basketball.
          </SectionDescription>
        </SectionHeader>
        <FeaturesGrid>
          <ImageCard>
            <ImagePlaceholder style={{ backgroundImage: 'url("https://lh3.googleusercontent.com/aida-public/AB6AXuD7LR3rgU_UhSSj7C5CIZ4yGYPt8UzD-dfSzyTObQUrv7aiNiX3uKdXdRI1odyY_eed-uwBjc0JcJRWeGH8xE0164LuF9YhNy1IlLvReobku_YEENi3NXSrwEVEMQ2TVnquuThdqe9Kpy2WyFTqsGvltLCSXu0w6wVEE8qeVVQRN7vHOavR007F30u20oYhTDB8REuu9MGC-f9xm_sz7btKthp9jhXARfTUi_oAkx3WvuYHzIr5Z83hnjFyF1TOjU-actsFYY4jGXc")' }} />
            <div>
              <ImageCardTitle>Player Comparison</ImageCardTitle>
              <ImageCardDescription>Compare individual player stats, strengths, and areas for improvement.</ImageCardDescription>
            </div>
          </ImageCard>
          <ImageCard>
            <ImagePlaceholder style={{ backgroundImage: 'url("https://lh3.googleusercontent.com/aida-public/AB6AXuDxZUox8t4J2GTJKoRc9Xybzhe37SGLn4yy4pvXdQZbBHsyHnj6cYA1LHhguIC1D9nnyngdLHpM_0BHxIus8j1veFf-O6audcKdh6HWCxL5euFwwFmucP2S6vOwMik2rIkQAE5rExFeVV4X-YYE7V6Gt-YsJguSVoNoinD-PGeiV6gYc4z-0ws6hEGRMX3LIIWRcOvhEYArNAhc9V3WZrHQXjqfsS8YFPJVUAYtb5jOcMeOs-QLnSW42PPuAVaemSAxPS8fnpAzvl0")' }} />
            <div>
              <ImageCardTitle>Point, Rebound, Assist Analysis</ImageCardTitle>
              <ImageCardDescription>Analyze points, rebounds, and assists to understand player contributions.</ImageCardDescription>
            </div>
          </ImageCard>
          <ImageCard>
            <ImagePlaceholder style={{ backgroundImage: 'url("https://lh3.googleusercontent.com/aida-public/AB6AXuD97KOMYEdz7FQpS9xONwOom2tRCMjx0ozupUKWaMI9AZjZXGYLgPrGqSMb2kQHSSw9tPqSyOggOGvDaFNuzDh9QYV0cgfIkh8fWL6WVHE1h0beSP0bBCbLcP293LLM6mcRb_Zg0TvAu4_aANDv_e0rFhIbdAmFWdaSb1SyCB9xZFrS9aAdxLq48t76thhMKzwqDBmWrD9tU-evXB49DfhEtVAFi_Xue5GGC2cwYdyUp2ZSM4-6ogUX8j88AAabbLM7vBvIdBydXeI")' }} />
            <div>
              <ImageCardTitle>Team Score Predictions</ImageCardTitle>
              <ImageCardDescription>Predict team scores and compare them to other teams.</ImageCardDescription>
            </div>
          </ImageCard>
        </FeaturesGrid>
      </SectionWrapper>

      <CTAWrapper>
        <CTABlock>
          <CTATextContent>
            <CTATitle>Ready to Elevate Your Game?</CTATitle>
            <CTADescription>
              Join our community of basketball analysts and enthusiasts. Sign up today and start exploring the data that drives success.
            </CTADescription>
          </CTATextContent>
          <CTAButtonContainer>
          <Link to="/signup"  style={{ textDecoration: 'none', color: 'inherit' }} >

            <CTAButtonInner>
              <CTAButton><span>Get Started</span></CTAButton>
            </CTAButtonInner>
            </Link>
          </CTAButtonContainer>
        </CTABlock>
      </CTAWrapper>
      <FooterSpacer />
    </div>
  </div>
);

export default Home;